import {fetchWrapper} from './restApi';

export const getCategories = () => {
  return fetchWrapper('/api/categories/');
};
